import api from "./api";
import TokenService from "./token.service";
import axios from "axios";

  // class for authenitcation api calls 
class AuthService {

  forgotPassword(email) {
    let payload = {
      userEmail: email
    };

    return api.post('https://vop.olympusmarinegroup.com:8082/forgotpassword', payload);
  }



  //login to authserver and get token and user details 
  loginService({ username, password }) {
    var params = new URLSearchParams();
    params.append('grant_type', 'password');
    params.append('username', username);
    params.append('password', password);


    return axios({
      method: 'POST',
      baseURL: 'https://vop.olympusmarinegroup.com:8082/oauth/token',
      // url: 'oauth/token',
      auth: { username: 'cantapermevop', password: '5799E092FB55679B69A28735859893410F761FD1872EF63432870ED6521CCA06' },
      headers: {
        "Content-type": "application/x-www-form-urlencoded; charset=utf-8"
      },
      data: params


    })
      .then((response) => {
        if (response.data.access_token) {
          TokenService.setUser(response.data);
        }


        return response;
      });

  }




}


export default new AuthService();